import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { customGetAPI } from "services/utils/CustomAPI";
// import sessionHandling from "services/utils/notificationUtils";
import { defaultAllSelection } from "services/constants";
import { setAttendanceScreenView } from "services/Redux/userManagament";
import { showToast } from "services/utils/Status";
import { setGlobalSearchValue } from "services/Redux/userToken";
import { CustomAutoComplete } from "components/CustomComponents/CustomAutoComplete";
import BSDateRangePicker from "pages/MyZone/Status/DateRangePicker";
import ListIcon from "@mui/icons-material/List";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import * as Mui from "@mui/material";
import * as Icons from "@mui/icons-material";
import moment from "moment";
import { useSelector } from "react-redux";
import { useFetch } from "services/hooks/useFetch";
import { themes } from "services/constants";
import { AttendanceStatus } from "./AttendanceStatus";
import { AttendanceTimeLine } from "./AttendanceTimeLine";
import { Reports } from "./Reports";
import { timeLineLabelList } from "services/constants";
import {
  // setAttendanceCompanyId,
  // setAttendanceCompanyName,
  setAttendanceShiftName,
  setAttendanceShiftId,
  setAttendanceDate,
} from "services/Redux/TeamZone";
import { tooltipStyleProps } from "services/constants/Styles";
const keys = ["user", "department"];
const tab_options = ["Status", "Time Line"];

export const Attendance = () => {
  const { domain, globalSearchValue, userDetails, topbarCompanyId } =
    useSelector((state) => state.tokenReducer);
  const {
    // attendanceCompanyName,
    // attendanceCompanyId,
    attendanceShiftName,
    attendanceShiftId,
    attendanceDate,
  } = useSelector((state) => state.teamZoneReducer);
  const [deviceOffine, setDeviceOffline] = useState(false);
  const { attendanceScreenView } = useSelector((state) => state.userReducer);
  const [userDataViewMethod, setUserDataViewMethod] =
    useState(attendanceScreenView);
  const [reloadAPIForCard, setReloadAPIForCard] = useState(true);
  // const [companyName, setCompanyName] = useState(attendanceCompanyName);
  // const [companyNameId, setCompanyNameId] = useState(attendanceCompanyId);
  const [shiftData, setShiftData] = useState([]);
  const [shiftName, setShiftName] = useState(attendanceShiftName);
  const [shiftId, setShiftId] = useState(attendanceShiftId);
  const [date, setDate] = useState(attendanceDate);
  // const [companyDetails, setCompanyDetails] = useState([]);
  // const today = new Date();
  const [trigger, setTrigger] = useState(true);
  // const startOfWeek = new Date(today);
  // startOfWeek.setDate(today.getDate() - today.getDay() + 1);
  // const endOfWeek = new Date(startOfWeek);
  // endOfWeek.setDate(startOfWeek.getDate() + 6);
  // const formattedStart = startOfWeek.toISOString().split("T")[0];
  // const formattedEnd = endOfWeek.toISOString().split("T")[0];
  const [departmentName, setDepartmentName] = useState("All Department");
  const [departmentId, setDepartmentId] = useState("99999");
  const [startDate, setStartDate] = useState(
    moment().subtract(7, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment().subtract(1, "days").format("YYYY-MM-DD")
  );
  const theme = Mui.useTheme();
  const isMobile = Mui.useMediaQuery(theme.breakpoints.down("sm"));
  const [leavePage, setLeavePage] = useState(0);
  const [attendanceDataDetails, setAttendanceDataDetails] = useState([]);
  const [advanceSalary, setAdvanceSalary] = useState("Status");
  const [selectedLabel, setSelectedLabel] = useState(["All"]);
  const [selectedComponent, setSelectedComponent] = useState("Status");
  const { result: allDepartmentDetails } = useFetch(
    `${domain}get-department/?user_id=${userDetails?.id}`
  );

  const departmentDetails = [
    {
      id: 99999,
      department_name: "All Department",
    },
    ...allDepartmentDetails,
  ];

  const {
    result: attendanceDetails,
    setLoad: reCallPayScheduleApi,
    loading,
  } = useFetch(
    `${domain}attendance-timeline/?department_id=${departmentId}&user_id=${
      userDetails?.id
    }&start_date=${startDate.split("/").reverse().join("-")}&end_date=${endDate
      .split("/")
      .reverse()
      .join("-")}&company_id=${topbarCompanyId}&status=${
      selectedLabel.includes("All") || selectedLabel?.length === 0
        ? ""
        : `[${selectedLabel}]`
    }`
  );

  useEffect(() => {
    if (topbarCompanyId) {
      reCallPayScheduleApi(true);
    }
  }, [reCallPayScheduleApi, topbarCompanyId]);

  // useEffect(() => {
  //   const getCompany = async () => {
  //     try {
  //       const response = await fetch(`${domain}get-active-company/`, {
  //         method: "GET",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `token ${token}`,
  //         },
  //       });
  //       const res = await response.json();
  //       if (response.ok) {
  //         const companyDetailsWithLabel = res.map((obj) => ({
  //           ...obj,
  //           label: obj.companyname,
  //         }));
  //         const allCompanies = {
  //           id: defaultAllSelection,
  //           label: "All Companies",
  //           companyname: "All Companies",
  //         };
  //         setCompanyDetails([allCompanies, ...companyDetailsWithLabel]);
  //       } else if (response.status === 409) {
  //         sessionHandling();
  //       } else {
  //         throw new Error(res.error);
  //       }
  //     } catch (error) {
  //       showToast("error", error.message);
  //     }
  //   };
  //   getCompany();
  // }, [domain, token]);

  useEffect(() => {
    const fetchShiftDetailsDetails = async () => {
      const allShifts = {
        id: defaultAllSelection,
        label: "All",
        name: "All",
      };
      const res = await customGetAPI(
        `${domain}shift-filter/?department_id=99999&user_id=${userDetails?.id}&date=${date}`
      );
      if (res.ok) {
        let data =
          res?.responseDetails?.length !== 0
            ? [allShifts, ...res?.responseDetails]
            : [allShifts];
        setShiftData(data);
      } else {
        setShiftData(allShifts);
      }
    };
    if (date !== "") {
      fetchShiftDetailsDetails();
    }
  }, [date, domain, userDetails?.id]);

  useEffect(() => {
    if (
      attendanceDetails?.attendance_data?.length !== 0 ||
      attendanceDetails?.attendance_data?.length === 0
    ) {
      const filteredResults = attendanceDetails?.attendance_data?.filter(
        (item) =>
          keys.some((key) =>
            item[key]
              ?.toString()
              .toLowerCase()
              .includes(globalSearchValue.toString().toLowerCase())
          )
      );
      setAttendanceDataDetails(filteredResults);
      setLeavePage(0);
    }
  }, [globalSearchValue, attendanceDetails]);

  const handleDepartmentName = (event, data) => {
    if (data) {
      setDepartmentId(data?.id);
      setDepartmentName(data?.label);
      setTimeout(function () {
        reCallPayScheduleApi(true);
      }, 150);
    } else {
      setDepartmentId("");
      setDepartmentName("");
    }
  };

  const dispatch = useDispatch();

  const renderComponent = () => {
    switch (selectedComponent) {
      case "Status":
        return (
          <AttendanceStatus
            // companyNameId={companyNameId}
            shiftId={shiftId}
            date={date}
            setReloadAPIForCard={setReloadAPIForCard}
            reloadAPIForCard={reloadAPIForCard}
            userDataViewMethod={userDataViewMethod}
            setDeviceOffline={setDeviceOffline}
            deviceOffine={deviceOffine}
          />
        );
      case "Time Line":
        return (
          <AttendanceTimeLine
            leavePage={leavePage}
            setLeavePage={setLeavePage}
            attendanceDetails={attendanceDetails}
            attendanceDataDetails={attendanceDataDetails}
            loading={loading}
            reCallPayScheduleApi={reCallPayScheduleApi}
          />
        );
      case "Reports":
        return <Reports />;
      default:
        break;
    }
  };

  const handleStartDate = async (startDate, endDate) => {
    setStartDate(startDate);
    setEndDate(endDate);
    if (!trigger) {
      setTimeout(function () {
        reCallPayScheduleApi(true);
      }, 150);
    } else {
      setTrigger(false);
    }
  };

  const handleSelection = (event, newValue) => {
    if (newValue) {
      dispatch(setGlobalSearchValue(""));
      setAdvanceSalary(newValue);
      setSelectedComponent(newValue);
    }
  };

  // const handleCompanyName = (event, data) => {
  //   if (data) {
  //     setCompanyNameId(data?.id);
  //     setCompanyName(data?.label);
  //     setReloadAPIForCard(true);
  //     dispatch(setAttendanceCompanyId(data?.id));
  //     dispatch(setAttendanceCompanyName(data?.label));
  //     localStorage.setItem("attendanceCompanyId", data?.id);
  //     localStorage.setItem("attendanceCompanyName", data?.label);
  //   }
  // };

  const handleShiftname = (event, data) => {
    if (data) {
      setShiftName(data?.label);
      setShiftId(data?.id);
      setReloadAPIForCard(true);
      dispatch(setAttendanceShiftId(data?.id));
      dispatch(setAttendanceShiftName(data?.label));
      localStorage.setItem("attendanceShiftId", data?.id);
      localStorage.setItem("attendanceShiftName", data?.label);
    }
  };

  const handleChange = (event) => {
    const value = event.target.value;
    if (value !== "") {
      if (/^\d{0,4}-?\d{0,2}-?\d{0,2}$/.test(value)) {
        dispatch(setAttendanceDate(value));
        localStorage.setItem("attendanceDate", value);
        setDate(value);
        setReloadAPIForCard(true);
      }
    } else {
      setDate(value);
    }
  };

  const handleBlur = () => {
    if (date !== "") {
      const dateFormatRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (dateFormatRegex.test(date)) {
        const inputDate = moment(date, "YYYY-MM-DD");
        if (inputDate.isValid()) {
          setDate(inputDate.format("YYYY-MM-DD"));
        } else {
          showToast("error", "Invalid date format");
        }
      } else {
        showToast("error", "Invalid date format");
      }
    }
  };

  return (
    <React.Fragment>
      <Mui.Grid
        container
        spacing={2}
        alignItems="center"
        sx={{ pr: 1, pl: 1, paddingTop: 3, flexWrap: "wrap" }}
      >
        <Mui.Grid item xs={12} md={5.5} lg={5.5}>
          <Mui.Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              maxWidth: { xs: "100%", sm: 500 },
            }}
          >
            {isMobile ? (
              <Mui.FormControl fullWidth>
                <Mui.Select
                  size="small"
                  id="option-select-label"
                  value={advanceSalary}
                  fullWidth
                  sx={{
                    fontSize: 16,
                  }}
                  onChange={(e) => handleSelection(null, e.target.value)}
                  renderValue={(selected) => selected}
                >
                  {tab_options.map((item) => (
                    <Mui.MenuItem key={item} value={item}>
                      <Mui.ListItemText primary={item} />
                    </Mui.MenuItem>
                  ))}
                </Mui.Select>
              </Mui.FormControl>
            ) : (
              <Mui.ToggleButtonGroup
                value={advanceSalary}
                exclusive
                onChange={handleSelection}
                sx={{
                  display: "flex",
                  width: "100%",
                  borderRadius: "30px",
                  backgroundColor: "#e0e0e0",
                  flexWrap: "wrap",
                }}
              >
                {tab_options.map((item) => (
                  <Mui.ToggleButton
                    key={item}
                    value={item}
                    sx={{
                      flex: 1,
                      textTransform: "capitalize",
                      fontSize: 16,
                      fontWeight: 600,
                      borderRadius: "30px",
                      border: "none",
                      color:
                        advanceSalary === item
                          ? themes.whiteColor
                          : themes.headLine,
                      backgroundColor:
                        advanceSalary === item
                          ? themes.headLine
                          : themes.lightBrown,
                      "&.Mui-selected, &.Mui-selected:hover": {
                        backgroundColor: themes.headLine,
                        color: themes.whiteColor,
                        borderRadius: "30px",
                      },
                      "&:hover, &:focus": {
                        backgroundColor:
                          advanceSalary === item
                            ? themes.headLine
                            : themes.lightBrown,
                        color:
                          advanceSalary === item
                            ? themes.whiteColor
                            : themes.headLine,
                      },
                    }}
                  >
                    {item}
                  </Mui.ToggleButton>
                ))}
              </Mui.ToggleButtonGroup>
            )}
          </Mui.Box>
        </Mui.Grid>

        <Mui.Grid
          item
          xs={selectedComponent === "Time Line" ? 0 : 12}
          sm={selectedComponent === "Time Line" ? 0 : 6}
          md={selectedComponent === "Time Line" ? 0 : 1.8}
        ></Mui.Grid>
        {selectedComponent !== "Time Line" ? (
          userDataViewMethod !== "PlanShift" ? (
            <Mui.Grid item xs={12} sm={6} md={0.5}>
              <Mui.IconButton
                aria-label="close"
                onClick={() => {
                  dispatch(
                    setAttendanceScreenView(
                      userDataViewMethod === "ListView"
                        ? "CardView"
                        : "ListView"
                    )
                  );
                  setUserDataViewMethod(
                    userDataViewMethod === "ListView" ? "CardView" : "ListView"
                  );
                }}
              >
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  key={userDataViewMethod}
                  title={
                    userDataViewMethod === "CardView" ? "ListView" : "CardView"
                  }
                  placement="bottom"
                >
                  {userDataViewMethod === "CardView" ? (
                    <ListIcon
                      style={{
                        fontSize: 40,
                        color: themes.bgIconColor,
                        fontWeight: "bold",
                      }}
                    />
                  ) : (
                    <CreditCardIcon
                      style={{
                        fontSize: 40,
                        color: themes.bgIconColor,
                        fontWeight: "bold",
                      }}
                    />
                  )}
                </Mui.Tooltip>
              </Mui.IconButton>
            </Mui.Grid>
          ) : null
        ) : null}
        {selectedComponent === "Time Line" ? (
          <Mui.Grid item xs={12} sm={6} md={2}>
            <CustomAutoComplete
              dataList={departmentDetails.map((obj) => ({
                ...obj,
                label: obj.department_name,
              }))}
              selectedValue={departmentName}
              updateDataFunction={handleDepartmentName}
              placeHolder="Select the department name"
              label="Department"
            />
          </Mui.Grid>
        ) : // <Mui.Grid item xs={12} sm={6} md={2}>
        //   <CustomAutoComplete
        //     dataList={companyDetails}
        //     selectedValue={companyName}
        //     updateDataFunction={handleCompanyName}
        //     placeHolder="Select company name"
        //     label="company"
        //   />
        // </Mui.Grid>
        null}

        {selectedComponent === "Time Line" ? (
          <Mui.Grid item xs={12} sm={6} md={2}>
            <Mui.Autocomplete
              multiple
              limitTags={1}
              id="multiple-limit-tags"
              size="small"
              options={timeLineLabelList}
              disableCloseOnSelect
              getOptionLabel={(option) => option.label}
              ListboxProps={{ style: { maxHeight: "150px" } }}
              sx={{
                width: "100%",
              }}
              value={
                timeLineLabelList?.filter((member) =>
                  selectedLabel.includes(member.label)
                ) || []
              }
              onChange={(event, value) => {
                const newLabels = value.map((item) => item.label);
                setSelectedLabel(
                  newLabels.length > 1
                    ? newLabels.filter((label) => label !== "All")
                    : newLabels
                );
                setTimeout(() => {
                  reCallPayScheduleApi(true);
                }, 150);
              }}
              renderOption={(props, option, { selected }) => {
                const { key, ...optionProps } = props;
                return (
                  <li key={key} {...optionProps}>
                    <Mui.Checkbox
                      icon={<Icons.CheckBoxOutlineBlank fontSize="small" />}
                      checkedIcon={<Icons.CheckBox fontSize="small" />}
                      checked={selected}
                    />
                    {option.label}
                  </li>
                );
              }}
              renderInput={(params) => (
                <Mui.TextField {...params} label="Labels" />
              )}
            />
          </Mui.Grid>
        ) : (
          <Mui.Grid item xs={12} sm={6} md={2}>
            <CustomAutoComplete
              dataList={shiftData?.map((obj) => ({
                ...obj,
                label: obj.name,
              }))}
              selectedValue={shiftName}
              updateDataFunction={handleShiftname}
              placeHolder="Select the shift"
              label="Shift"
            />
          </Mui.Grid>
        )}
        {selectedComponent === "Time Line" ? (
          <Mui.Grid item xs={12} sm={6} md={3.5} lg={2}>
            <BSDateRangePicker
              handleStartDate={handleStartDate}
              showToday={true}
              triggerDate={true}
            />
          </Mui.Grid>
        ) : (
          <Mui.Grid item xs={12} sm={6} md={3.5} lg={2}>
            <Mui.TextField
              type="date"
              size="small"
              label="Date"
              value={date}
              onChange={handleChange}
              onBlur={handleBlur}
              fullWidth
            />
          </Mui.Grid>
        )}
      </Mui.Grid>
      {renderComponent()}
    </React.Fragment>
  );
};
